module.exports = __webpack_public_path__ + "static/img/zulin.42a27752.png";